<template>
  <footer class="container">
    <!-- Footer Section start -->

    <div class="py-4 py-lg-5 row align-items-center justify-content-lg-between justify-content-center">
      <div class="d-flex justify-content-center align-items-center mb-2 mb-lg-0">
        <a class="mb-2 mb-lg-0" href="#">
          <img class="img" src="../assets/images/facebook.svg" alt="Facebook">
        </a>
        <p type="button" class="btn btn-outline-success btn-outline-weserve ml-4 mb-2 mb-lg-0">
          <i class="material-icons mr-2">
            phone
          </i>
          +66 02 105 4632
        </p>
        <p type="button" class="btn btn-outline-success btn-outline-weserve ml-4 mb-2 mb-lg-0">
          <i class="material-icons mr-2">
            mail
          </i>
          Cloud@weservego.asia
        </p>
      </div>
      <span class="f-300">&#169; Copyright 2022. All Rights Reserved</span>
    </div>
    <!-- Footer Section End -->
    <!-- Tap on Top -->
    <div class="tap-top">
      <div>
        <i class="fa fa-angle-double-up"></i>
      </div>
    </div>
    <!-- Tap on Ends -->
    <!-- <color/> -->
  </footer>
</template>
<script>
export default {
  name: 'Footer',
}
</script>

<style lang="sass" scoped>
  .btn-outline-weserve
    background: transparent
    color: #41C2AD
    border-radius: 8px
    border: 1.5px solid #40C1AC 
    font-weight: 600
    display: flex
    align-items: center

    @media (max-width: 568px)
      font-size: 11px 
      i 
        font-size: 14px

    @media (max-width: 378px)
      font-size: 9px 
      i 
        font-size: 12px
    
  .btn-outline-weserve:hover
    background: #40C1AC
    color: #fff
    border: 1.5px solid #40C1AC

  .img
    max-height: 40px

    @media (max-width: 568px)
        max-height: 30px
</style>


// WEBPACK FOOTER //
// src/components/footer.vue